function initLazyExternalScripts() {
    const externalScripts = document.querySelectorAll("[data-lazyscript]");

    if (externalScripts) {
        externalScripts.forEach(item => {
            item.setAttribute("src", item.dataset.src);
        });
    }
}

window.addEventListener("load", () => initLazyExternalScripts());
